module.exports = __webpack_public_path__ + "static/img/3.2a8b761.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/3.jpg
// module id = ltpL
// module chunks = 1